module.exports = __webpack_public_path__ + "img/LogoInfo1.3a78864c.png";